import React from "react";
import { Table, Tbody, Td } from "./BiBleYear.style";

const SixtyTwoToNinetyOne = () => {
  return (
    <Table>
      <Tbody>
        <tr>
          <Td>62</Td>
          <Td>กันดารวิถี 10,11</Td>
          <Td>กิจการ 17</Td>
          <Td>Numbers 10,11</Td>
          <Td>Acts 17</Td>

          <Td>มอบภาระแด่พระเจ้า</Td>
        </tr>
        <tr>
          <Td>63</Td>
          <Td>กันดารวิถี 12-14</Td>
          <Td>สดุดี 28,29</Td>
          <Td>Numbers 12-14</Td>
          <Td>Psalms 28,29</Td>

          <Td>ท้อแท้แต่ไม่ถอย</Td>
        </tr>
        <tr>
          <Td>64</Td>
          <Td>กันดารวิถี 15,16</Td>
          <Td>กิจการ 18</Td>
          <Td>Numbers 15,16</Td>
          <Td>Acts 18</Td>

          <Td>คุณเอาใจใคร?</Td>
        </tr>
        <tr>
          <Td>65</Td>
          <Td>กันดารวิถี 17-19</Td>
          <Td>กิจการ 19</Td>
          <Td>Numbers 17-19</Td>
          <Td>Acts 19</Td>

          <Td>รับผลจากการกระทำ</Td>
        </tr>
        <tr>
          <Td>66</Td>
          <Td>กันดารวิถี 20,21</Td>
          <Td>กิจการ 20</Td>
          <Td>Numbers 20,21</Td>
          <Td>Acts 20</Td>

          <Td>ทั้งยามสุขและยามทุกข์</Td>
        </tr>
        <tr>
          <Td>67</Td>
          <Td>กันดารวิถี 22,23</Td>
          <Td>สดุดี 30</Td>
          <Td>Numbers 22,23</Td>
          <Td>Psalms 30</Td>

          <Td>เหตุผลที่ต้องขอบพระคุณ</Td>
        </tr>
        <tr>
          <Td>68</Td>
          <Td>กันดารวิถี 24,25</Td>
          <Td>กิจการ 21</Td>
          <Td>Numbers 24,25</Td>
          <Td>Acts 21</Td>

          <Td>การเชื่อฟังและความเชื่อ</Td>
        </tr>
        <tr>
          <Td>69</Td>
          <Td>กันดารวิถี 26,27</Td>
          <Td>กิจการ 22</Td>
          <Td>Numbers 26,27</Td>
          <Td>Acts 22</Td>

          <Td>เป็นพยานตลอดเวลา</Td>
        </tr>
        <tr>
          <Td>70</Td>
          <Td>กันดารวิถี 28,29</Td>
          <Td>สดุดี 31</Td>
          <Td>Numbers 28,29</Td>
          <Td>Psalms 31</Td>

          <Td>มีนัดกับพระเจ้า</Td>
        </tr>
        <tr>
          <Td>71</Td>
          <Td>กันดารวิถี 30,31</Td>
          <Td>กิจการ 23</Td>
          <Td>Numbers 30,31</Td>
          <Td>Acts 23</Td>

          <Td>สำนึกผิดชัดเจน</Td>
        </tr>
        <tr>
          <Td>72</Td>
          <Td>กันดารวิถี 32,33</Td>
          <Td>กิจการ 24</Td>
          <Td>Numbers 32,33</Td>
          <Td>Acts 24</Td>

          <Td>จงรักภักดีและจริงใจ</Td>
        </tr>
        <tr>
          <Td>73</Td>
          <Td>กันดารวิถี 34,35</Td>
          <Td>กิจการ 25</Td>
          <Td>Numbers 34,35</Td>
          <Td>Acts 25</Td>

          <Td>ในที่เหมาะสมไหม?</Td>
        </tr>
        <tr>
          <Td>74</Td>
          <Td>
            กันดารวิถี 36
            <br />
            เฉลยธรรมบัญญัติ 1
          </Td>
          <Td>สดุดี 32</Td>
          <Td>
            Numbers 36
            <br />
            Deuteronomy 1
          </Td>
          <Td>Psalms 32</Td>

          <Td>ภายในขอบเขตที่กำหนด</Td>
        </tr>
        <tr>
          <Td>75</Td>
          <Td>เฉลยธรรมบัญญัติ 2,3</Td>
          <Td>กิจการ 26</Td>
          <Td>Deuteronomy 2,3</Td>
          <Td>Acts 26</Td>

          <Td>อย่าให้สายตาคลาดจากเป้า</Td>
        </tr>
        <tr>
          <Td>76</Td>
          <Td>เฉลยธรรมบัญญัติ 4,5</Td>
          <Td>กิจการ 27</Td>
          <Td>Deuteronomy 4,5</Td>
          <Td>Acts 27</Td>

          <Td>เหมือนอย่างคำเตือน</Td>
        </tr>
        <tr>
          <Td>77</Td>
          <Td>เฉลยธรรมบัญญัติ 6,7</Td>
          <Td>สดุดี 33</Td>
          <Td>Deuteronomy 6,7</Td>
          <Td>Psalms 33</Td>

          <Td>ถวายเกียรติแด่พระเจ้า</Td>
        </tr>
        <tr>
          <Td>78</Td>
          <Td>เฉลยธรรมบัญญัติ 8,9</Td>
          <Td>กิจการ 28</Td>
          <Td>Deuteronomy 8,9</Td>
          <Td>Acts 28</Td>

          <Td>เข้าครอบครองดินแดน</Td>
        </tr>
        <tr>
          <Td>79</Td>
          <Td>เฉลยธรรมบัญญัติ 10,11</Td>
          <Td>โรม 1</Td>
          <Td>Deuteronomy 10,11</Td>
          <Td>Romans 1</Td>

          <Td>สิ่งที่พระเจ้าต้องประสงค์</Td>
        </tr>
        <tr>
          <Td>80</Td>
          <Td>เฉลยธรรมบัญญัติ 12-14</Td>
          <Td>โรม 2</Td>
          <Td>Deuteronomy 12-14</Td>
          <Td>Romans 2</Td>

          <Td>นมัสการที่แท้จริง</Td>
        </tr>
        <tr>
          <Td>81</Td>
          <Td>เฉลยธรรมบัญญัติ 15,16</Td>
          <Td>สดุดี 34</Td>
          <Td>Deuteronomy 15,16</Td>
          <Td>Psalms 34</Td>

          <Td>อย่าลืมว่าเป็นอิสระแล้ว</Td>
        </tr>
        <tr>
          <Td>82</Td>
          <Td>เฉลยธรรมบัญญัติ 17,18</Td>
          <Td>โรม 3</Td>
          <Td>Deuteronomy 17,18</Td>
          <Td>Romans 3</Td>

          <Td>พระเจ้าทรงจัดเตรียมแล้ว</Td>
        </tr>
        <tr>
          <Td>83</Td>
          <Td>เฉลยธรรมบัญญัติ 19,20</Td>
          <Td>โรม 4</Td>
          <Td>Deuteronomy 19,20</Td>
          <Td>Romans 4</Td>

          <Td>ทำผิด - และบริสุทธิ์</Td>
        </tr>
        <tr>
          <Td>84</Td>
          <Td>เฉลยธรรมบัญญัติ 21,22</Td>
          <Td>สดุดี 35</Td>
          <Td>Deuteronomy 21,22</Td>
          <Td>Psalms 35</Td>

          <Td>ช่วยชีวิตและชำระหนี้</Td>
        </tr>
        <tr>
          <Td>85</Td>
          <Td>เฉลยธรรมบัญญัติ 23,24</Td>
          <Td>โรม 5</Td>
          <Td>Deuteronomy 23,24</Td>
          <Td>Romans 5</Td>

          <Td>คืนดีกับพรระเจ้า</Td>
        </tr>
        <tr>
          <Td>86</Td>
          <Td>เฉลยธรรมบัญญัติ 25,26</Td>
          <Td>โรม 6</Td>
          <Td>Deuteronomy 25,26</Td>
          <Td>Romans 6</Td>

          <Td>สำคัญอยู่ที่การใช้ชีวิต</Td>
        </tr>
        <tr>
          <Td>87</Td>
          <Td>เฉลยธรรมบัญญัติ 27,28</Td>
          <Td>โรม 7</Td>
          <Td>Deuteronomy 27,28</Td>
          <Td>Romans 7</Td>

          <Td>จำไว้ว่าคุณเป็นของใคร</Td>
        </tr>
        <tr>
          <Td>88</Td>
          <Td>เฉลยธรรมบัญญัติ 29,30</Td>
          <Td>สดุดี 36</Td>
          <Td>
            Deuteronomy 29,30
            <br />
            &nbsp;
          </Td>
          <Td>Psalms 36</Td>

          <Td>ในความดูแลของพระเจ้า</Td>
        </tr>
        <tr>
          <Td>89</Td>
          <Td>เฉลยธรรมบัญญัติ 31,32</Td>
          <Td>โรม 8</Td>
          <Td>Deuteronomy 31,32</Td>
          <Td>Romans 8</Td>

          <Td>อ้างสิทธิของทายาท</Td>
        </tr>
        <tr>
          <Td>90</Td>
          <Td>เฉลยธรรมบัญญัติ 33,34</Td>
          <Td>โรม 9</Td>
          <Td>Deuteronomy 33,34</Td>
          <Td>Romans 9</Td>

          <Td>เจ้าเป็นประชากรของเรา</Td>
        </tr>
        <tr>
          <Td>91</Td>
          <Td>โยชูวา 1-3</Td>
          <Td>สดุดี 37</Td>
          <Td>Joshua 1-3</Td>
          <Td>Psalms 37</Td>

          <Td>วางใจและเดินหน้าต่อไป</Td>
        </tr>
      </Tbody>
    </Table>
  );
};

export default SixtyTwoToNinetyOne;
